module.exports = __webpack_public_path__ + "static/media/talkback.dc019273.png";